// Theme management for the RaconWorks app (light / dark, persisted).
const STORAGE_KEY = 'rw-theme';

export function getTheme() {
    try {
        const saved = localStorage.getItem(STORAGE_KEY);
        if (saved === 'light' || saved === 'dark') return saved;
    } catch (_) { /* ignore */ }
    return 'dark'; // default
}

export function applyTheme(theme) {
    const t = theme === 'light' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', t);
    return t;
}

export function setTheme(theme) {
    const t = applyTheme(theme);
    try { localStorage.setItem(STORAGE_KEY, t); } catch (_) { /* ignore */ }
    window.dispatchEvent(new CustomEvent('rw-theme-change', { detail: t }));
    return t;
}

export function toggleTheme() {
    return setTheme(getTheme() === 'dark' ? 'light' : 'dark');
}

// Set the attribute as early as possible to avoid a flash.
export function initTheme() {
    return applyTheme(getTheme());
}
